import { gql } from '@apollo/client'

export const GET_REPORT_POWERBI_BY_PATHNAME = gql`
  query GetReportPowerBiByPathnameModule($pathnameModule: String!) {
    getReportPowerBiByPathnameModule(pathname_module: $pathnameModule) {
      id
      embed_url
      module_id
      pathname_module
      power_bi_id
      sub_module_id
      type
      is_active
    }
  }
`
